// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__qNdIL","imgContainer":"Skill_imgContainer__x-SUK"};